// Module-level store for route guards.
// TanStack Router's beforeLoad runs outside React tree, so it can't access React context.
// CompanyProvider writes to this on mount and on switch.

let currentLevel = 0;
let currentSlug = '';

export function setCompanyStore(slug: string, level: number) {
  currentSlug = slug;
  currentLevel = level;
}

export function getCompanyStore() {
  return { slug: currentSlug, level: currentLevel };
}
